import validate from 'validate.js';
import {differenceInMinutes, parseJSON} from 'date-fns';

const constraints = {
  nombre: {
    presence: {
      allowEmpty: false,
      message: 'es obligatorio'
    }
  },
  tipo: {
    presence: {
      allowEmpty: false,
      message: 'es obligatorio'
    }
  },
  color: {
    presence: {
      allowEmpty: false,
      message: 'es obligatorio'
    }
  },
};

export const validaTipoDeJornada = tipoDeJornada => (
    (tipoDeJornada ? validate(tipoDeJornada, constraints) : {}) || {}
);

export const horaDentroDeJornada = (tipo, hora) => {
  const horasLaborables = tipo.horas.map((hora) => ({
  }));
};